import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import './style.scss'

export default class MiniGraph extends Component {
    static propTypes = {
        data: PropTypes.array,
    }

    getRectHeight = (value, maxValue) => {
        const input = _.toNumber(value)

        // 11 is the maximum height of a graph column in pixels
        // If the value is zero set the column height to 1px
        if (_.isNaN(input) || input === 0 || _.isNil(input) || !_.isNumber(input)) return 1

        return _.round((Math.abs(input) / maxValue) * 11)
    }

    renderGraph = (values) => {
        const maxValue = Math.max(...values.map((x) => Math.abs(x)))

        if (values.length < 2) return null

        return _.map(values, (value, index) => {
            const rectHeight = this.getRectHeight(value, maxValue)

            return (
                <div
                    key={`mini-graph-column-${index}`}
                    className={classnames('mini-graph-column', value >= 0 && 'positive', value < 0 && 'negative')}
                    style={{
                        height: `${rectHeight}px`,
                        marginBottom: value < 0 ? `${11 - rectHeight}px` : '11px',
                    }}
                />
            )
        })
    }

    render() {
        const { data } = this.props

        return <div className={'mini-graph'}>{this.renderGraph(data)}</div>
    }
}
